import React, { useContext } from "react";
import { Button, Icon, Select } from "antd";
import style from "./index.module.scss";
import { useAtomValue } from "jotai";
import {
    CourseContext,
    CoursePlanAtom
} from "../../../pages/CourseDetail/Store";
import { sectionDescribe, weekHanzi } from "../../../Utils/filter";

interface Props {
    weekTimeId: number;
    onChange: (weekTimeId: number) => void;
    className?: string;
}
export default function WeekSelectPure({
    onChange,
    weekTimeId,
    className
}: Props) {
    const { course, path } = useContext(CourseContext);

    const list = useAtomValue(
        CoursePlanAtom({
            courseNo: course.courseNo,
            courseSeq: course.courseSeq
        })
    );

    function handlerSelectChange(weekTimeId: number) {
        onChange(weekTimeId);
    }

    const index = list.findIndex(
        item => Number(item.weekTimeId) === weekTimeId
    );

    function handleCheck(index: number) {
        const newWeekTimeId = Number(list[index].weekTimeId);
        handlerSelectChange(newWeekTimeId);
    }

    if (!list) return null;

    return (
        <div className={className}>
            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index - 1)}
                disabled={index === 0}>
                <Icon type="left" className={style.icon} />
            </Button>

            <Select
                className={style.root}
                value={weekTimeId}
                onChange={handlerSelectChange}
                showArrow={false}>
                {list.map(item => (
                    <Select.Option
                        value={item.weekTimeId}
                        key={item.weekTimeId}>
                        第{item.weekTime}周 {weekHanzi(item.week)}
                        {sectionDescribe(item.section, item.continunity)}
                    </Select.Option>
                ))}
            </Select>

            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index + 1)}
                disabled={index === list.length - 1}>
                <Icon type="right" className={style.icon} />
            </Button>
        </div>
    );
}
